import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { EntityContainer } from 'src/app/tools/models/entityContainer';
import { AssetOrderService } from '../../services/asset-order.service';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { AssetOrder } from '../../models/entities/asset-order';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';

@Component({
    selector: 'asset-order-list',
    templateUrl: './asset-order-list.component.html',
    styleUrls: ['./asset-order-list.component.scss']
})


export class AssetOrderListComponent extends BasePage2<AssetOrder> {

    assetOrders     : AssetOrder[] = [];
    code            : string;
    startDate       : Date;
    endDate         : Date;

    constructor(
        protected toastr            : ToastrService,
        protected assetOrderService : AssetOrderService,
        protected router            : Router,
        protected baseService       : BaseService,
        protected leanUtilsService  : LeanUtilsService, 
        protected location          : Location) {
         super(toastr, router, baseService, leanUtilsService, location);

         this.entityName = 'assetOrder';
    }

    ngAfterViewInit(){
        super.ngAfterViewInit();
        
    this.assetOrderService.assetOrdersGet(null, null, null, true).then(result => {
        this.assetOrders = result;
        })
    }
    

    initEntityContainer() {
        this.entityContainer = new EntityContainer(AssetOrder);
        this.entityContainer.row.theDate = new Date(); 
    }

    getRows(): AssetOrder[] {
        return this.assetOrders;
    }


    saveRow(row: AssetOrder): Promise<AssetOrder> {
        return this. assetOrderService.assetOrderSave(row);
    }

    loadData() {
        this. assetOrderService.assetOrdersGet(this.code, this.startDate, this.endDate, false).then(result => {
            this.assetOrders = result;
        }).catch(error => {
        })
    }

    newAssetOrder() {
        this.selectedRow            = new AssetOrder();
        let tmp                     = this.selectedRow as AssetOrder;
        tmp.theDate                 = new Date(); 
        this.selectedRow.edit       = true; 
        this.selectedRow.inserted   = true; 
    }

    selectRow(assetOrder : AssetOrder){
        if (assetOrder.inserted){
            this.selectedRow = assetOrder; 
            return;
        }
        let index : number = this.assetOrders.indexOf(assetOrder);
        this.assetOrderService.assetOrderGet(assetOrder.assetOrderCode).then(result => {
          this.assetOrders[index] = result;
          this.selectedRow = result; 
          })
      }

}
